import React from "react";

// Status color mapping (Indonesian order + availability statuses)
const MAP = {
  "MENUNGGU KONFIRMASI": "bg-[hsl(var(--info-bg))] text-[hsl(var(--info))] border-[hsl(var(--info)/0.25)]",
  "DICARI": "bg-slate-100 text-slate-700 border-slate-200",
  "DITEMUKAN": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "DIBELI": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "DIBAYAR": "bg-teal-50 text-teal-700 border-teal-200",
  "DALAM PERJALANAN": "bg-sky-50 text-sky-700 border-sky-200",
  "TIBA DI INDONESIA": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "SIAP DIANTAR": "bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.3)]",
  "DIANTAR": "bg-amber-50 text-amber-800 border-amber-200",
  "SELESAI": "bg-slate-900 text-white border-slate-900",
  "TIDAK DITEMUKAN": "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.3)]",
  "DIBATALKAN": "bg-zinc-100 text-zinc-600 border-zinc-200",
  // product availability
  "Tersedia": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "Dicari": "bg-slate-100 text-slate-700 border-slate-200",
  "Ditemukan": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "Tidak Ditemukan": "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.3)]",
  "Habis": "bg-orange-50 text-orange-800 border-orange-200",
  "Dibatalkan": "bg-zinc-100 text-zinc-600 border-zinc-200",
  // payment statuses
  "Belum Dibayar": "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.3)]",
  "Deposit": "bg-[hsl(var(--info-bg))] text-[hsl(var(--info))] border-[hsl(var(--info)/0.25)]",
  "Dibayar Sebagian": "bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.3)]",
  "Lunas": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "Refund Sebagian": "bg-orange-50 text-orange-800 border-orange-200",
  "Refund Penuh": "bg-zinc-100 text-zinc-600 border-zinc-200",
  // trip statuses
  "Planning": "bg-slate-100 text-slate-700 border-slate-200",
  "Open for Orders": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "Shopping": "bg-[hsl(var(--info-bg))] text-[hsl(var(--info))] border-[hsl(var(--info)/0.25)]",
  "Returning": "bg-sky-50 text-sky-700 border-sky-200",
  "Delivery": "bg-amber-50 text-amber-800 border-amber-200",
  "Completed": "bg-slate-900 text-white border-slate-900",
  "Cancelled": "bg-zinc-100 text-zinc-600 border-zinc-200",
  // quantity statuses
  "AVAILABLE": "bg-[hsl(var(--info-bg))] text-[hsl(var(--info))] border-[hsl(var(--info)/0.25)]",
  "SOLD OUT": "bg-purple-100 text-purple-700 border-purple-200",
  "OVERBOOKED": "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.3)]",
  "NOT PURCHASED": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "PURCHASE SHORTAGE": "bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.3)]",
  "QUANTITY MATCHED": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "SURPLUS STOCK": "bg-orange-50 text-orange-800 border-orange-200",
  // shopping list purchase statuses (Indonesian)
  "BELUM DIBELI": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "DIBELI SEBAGIAN": "bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.3)]",
  "PEMBELIAN LENGKAP": "bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
  "KELEBIHAN PEMBELIAN": "bg-orange-50 text-orange-800 border-orange-200",
  "DIGANTI PRODUK LAIN": "bg-purple-100 text-purple-700 border-purple-200",
};

export function StatusBadge({ status, className = "" }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span data-testid="status-badge" className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${cls} ${className}`}>
      {status}
    </span>
  );
}
